export const mutations = {
  PAGE_FETCH_PAGES: "FETCH_PAGES",
  PAGE_FETCH_ASSIGNMENTS: "FETCH_ASSIGNMENTS",
  PAGE_NEW_PAGE: "NEW_PAGE",
  PAGE_UPDATE_PAGES_FILTER: "UPDATE_PAGES_FILTER",
  PAGE_UPDATE_PAGES_PAGINATION: "UPDATE_PAGES_PAGINATION",
  PAGE_UPDATE_PAGES_STATUS: "UPDATE_PAGES_STATUS",
  PAGE_DELETE_PAGE: "DELETE_PAGE",
  PAGE_UPDATE_PAGE_INFO: "UPDATE_PAGE_INFO",
  PAGE_CLONE_PAGE: "CLONE_PAGE",
  PAGE_UPDATE_PAGES_STATUS_LIST: "UPDATE_PAGES_STATUS_LIST",
  PAGE_MAKE_DEFAULT: "MAKE_DEFAULT",

  PAGE_FETCH_TEMPLATES: "FETCH_TEMPLATES",
  UPDATE_PUBLISHED_COUNT: "UPDATE_PUBLISHED_COUNT",
  PAGE_UPDATE_TEMPLATES_STATUS_LIST: "UPDATE_TEMPLATES_STATUS_LIST",
  PAGE_UPDATE_TEMPLATES_STATUS: "UPDATE_TEMPLATES_STATUS",
  PAGE_ASSIGN_TEMPLATE: "ASSIGN_TEMPLATE",
  PAGE_UPDATE_ASSIGNMENTS_STATUS: "UPDATE_ASSIGNMENTS_STATUS",
  PAGE_UPDATE_ASSIGNMENTS_STATUS_LIST: "UPDATE_ASSIGNMENTS_STATUS_LIST",
  PAGE_FETCH_NEWEST_ITEMS: "FETCH_NEWEST_ITEMS",

  PAGE_UPDATE_RECENT_STATUS: "UPDATE_RECENT_STATUS",
  PAGE_DELETE_RECENT_PAGE: "DELETE_RECENT_PAGE",
  PAGE_DELETE_IN_SEARCH: "PAGE_DELETE_IN_SEARCH",

  PAGE_UPDATE_PAGE_INFO_RECENT_PAGE: "UPDATE_PAGE_INFO_RECENT_PAGE",
  PAGE_CLONE_RECENT_PAGE: "CLONE_RECENT_PAGE",
  PAGE_CLONE_RECENT_V2_PAGE: "CLONE_RECENT_V2_PAGE",

  PAGE_UPDATE_ASSIGNMENTS_PAGINATION: "UPDATE_ASSIGNMENTS_PAGINATION",

  PAGE_UPDATE_QUERY: "PAGE_UPDATE_QUERY",
  PAGE_UPDATE_GROUP_SELECTED: "PAGE_UPDATE_GROUP_SELECTED",

  PAGE_UPDATE_SEARCH_QUERY: "PAGE_UPDATE_SEARCH_QUERY",
  PAGE_UPDATE_SEARCH_LOADING: "PAGE_UPDATE_SEARCH_LOADING",
  PAGE_APPEND_SEARCH_DATA: "PAGE_APPEND_SEARCH_DATA",

  PAGE_SET_GROUP_ID: "PAGE_SET_GROUP_ID",
  PAGE_FETCH_ALL_ITEMS: "PAGE_FETCH_ALL_ITEMS",
  SEARCH_ITEMS: "SEARCH_ITEMS",
  PAGE_INCREASE_VIEW_TEMPLATE: "TEMPLATE_INCREASE_VIEW",
  UPDATE_GROUP_ID: "UPDATE_GROUP_ID",
  PAGE_SWITCH_PUBLISH: "PAGE_SWITCH_PUBLISH",
  DUPLICATE_TO: "DUPLICATE_TO",
  PAGE_MUTATE_JUST_UPDATED: "PAGE_MUTATE_JUST_UPDATED",
  MODIFY_LAYOUT: "MODIFY_LAYOUT",
  PAGE_UPDATE_ASSIGN_ALL_PRODUCT: "UPDATE_ASSIGN_ALL_PRODUCT",
  PAGE_UPDATE_ASSIGN_ALL_COLLECTION: "UPDATE_ASSIGN_ALL_COLLECTION",
  SET_FRAME_LOADING: "SET_FRAME_LOADING",
  SET_DEFAULT_PAGE_NAME: "SET_DEFAULT_PAGE_NAME",
  RESET_FETCHED_PAGE: "RESET_FETCHED_PAGE"
};

export const actions = {
  UPDATE_ASSIGNMENT_COUNT: 'updateAssigmentCount',
  FETCH_PAGES_PAGE: "fetchPages",
  FETCH_ASSIGNMENTS_PAGE: "fetchAssignments",
  NEW_PAGE_PAGE: "newPage",
  CREATE_PAGE_WITH_ONE_TAP: "createPageWithOneTap",
  UPDATE_PAGES_FILTER_PAGE: "updatePagesFilter",
  UPDATE_PAGES_PAGINATION_PAGE: "updatePagesPagination",
  DELETE_PAGE_PAGE: "deletePage",
  UPDATE_PAGE_INFO_PAGE: "updatePageInfo",
  MAKE_DEFAULT_PAGE: "makeDefault",
  FETCH_TEMPLATES_PAGE: "fetchTemplates",
  ASSIGN_TEMPLATE_PAGE: "assignTemplate",
  FETCH_NEWEST_ITEMS_PAGE: "fetchNewestItems",
  PUBLISH_PAGE:"linkPage",
  UNPUBLISH_PAGE:"unlinkPage",
  UNPUBLISH_PAGE_BY_ID:"unpublishPage",

  SEARCH_ANYTHING_PAGE: "searchAnything",
  SEARCH_ITEMS: "searchItems",
  SET_GROUP_ID_PAGE: "setGroupID",
  FETCH_ALL_ITEMS: "fetchAllItems",
  FETCH_ALL_ASSIGN_ITEMS: "fetchAllAssignItems",
  VIEW_TEMPLATE: "viewTemplate",
  DUPLICATE_TO: "duplicateTo",
  CLONE_PAGE_PAGE_V2: "clonePageV2",
  MODIFY_LAYOUT: "modifyLayout"
};
